import { noop } from '@saaga/shared/utils/noop.util'
import type { ReactNode } from 'react'

import { AddPaymentMethodContent } from './add-payment-method-content.molecule'
import type { TopUpBalanceContentProps } from './top-up-balance-content.molecule'
import { TopUpBalanceContent } from './top-up-balance-content.molecule'
import { UpgradePlanContent } from './upgrade-plan-content.molecule'
import type { UserInteractionContentData } from './user-interaction-content.interface'

export type TopUpBalanceState = Omit<TopUpBalanceContentProps, 'className'>

export interface UserInteractionContentProps {
  data: UserInteractionContentData
  onAddCard?: () => void
  isAddingCard?: boolean
  onUpgrade?: () => void
  isUpgrading?: boolean
  topUpState?: TopUpBalanceState
  className?: string
}

export const UserInteractionContent: React.FC<UserInteractionContentProps> = ({
  data,
  onAddCard,
  isAddingCard = false,
  onUpgrade,
  isUpgrading = false,
  topUpState,
  className,
}): ReactNode => {
  const { interaction } = data

  if (interaction.interactionType === 'add-credit-card') {
    return (
      <AddPaymentMethodContent
        onAddCard={onAddCard ?? noop}
        isLoading={isAddingCard}
        className={className}
      />
    )
  }

  if (interaction.interactionType === 'upgrade-plan') {
    return (
      <UpgradePlanContent
        onUpgrade={onUpgrade ?? noop}
        isLoading={isUpgrading}
        className={className}
      />
    )
  }

  if (interaction.interactionType === 'top-up-balance' && topUpState) {
    return <TopUpBalanceContent {...topUpState} className={className} />
  }

  return null
}
